<template>
    <div>
        <item-write-link v-for="writeLayout in writeLayouts" :key="`itemComp${writeLayout}`"
                         :writeLayout="writeLayout" :itemData="itemData"
                         :itemCategoryList="itemCategoryList"></item-write-link>
    </div>
</template>

<script>
import ItemWriteLink from "@/components/item/ItemWriteLink";
import itemUtil from "@/components/item/itemUtil";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
export default {
    name: "ItemWriteComponent",
    mixins: [itemUtil,alertMixins,awsS3FileUpload],
    components: {ItemWriteLink},
    provide() {
        return {
            itemWriteSetData: this.setData
        }
    },
    inject: ['changeLoading'],
    props: {
        itemType: {default: ''},
        itemKey: {default: ''},
    },
    data() {
        return {
            itemData: {},

            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            fileInfo: [],
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: '',
            writeFailTypes: {},
            deleteFunc:'',

            getFunc: '',
            detailApiParamsSet: {},

            memo: '',
            isAdult: 0,
            detailThumbnail: [],
            itemCategoryList: [],
            hashtag: [],
            deleteFiles:[],
            files:[]
        }
    },
    created() {
        this.getItemCategory()
        this.initConfig();
        this.getItem();

    },
    mounted() {
        EventBus.$on('itemWriteGetItem', this.getItem)
        EventBus.$on('writeItem', this.writeConfirm)
        EventBus.$on('deleteItem', this.deleteConfirm)
        EventBus.$on('setItemSellingStatus', this.setItemSellingStatus)
    },
    beforeDestroy() {
        EventBus.$off('itemWriteGetItem')
        EventBus.$off('writeItem')
        EventBus.$off('deleteItem')
        EventBus.$off('setItemSellingStatus')

    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let configItem = this.returnItemConfig(this.itemType);
            this.writeLayouts = configItem.writeLayouts;
            this.getFunc = configItem.getFunc;
            this.detailApiParamSet = configItem.detailApiParamsSet
            this.writeFunc = configItem.writeFunc;
            this.writeApiParamSet = configItem.writeApiParamSet;
            this.parsingData = configItem.parsingData;
            this.fileInfo = configItem.fileInfo;
            this.directUrl = configItem.directUrl;
            this.directType = configItem.directType;
            this.writeSuccessType = configItem.writeSuccessType;
            this.keyName = configItem.keyName;
            this.writeFailTypes = configItem.writeFailTypes;
            this.writeValidatorArr = configItem.writeValidatorArr;
            this.afterType = configItem.afterType;
            this.successMsg = configItem.successMsg;
            this.deleteFunc = configItem.deleteFunc;
            this.deleteApiParamSet = configItem.deleteApiParamSet;
            this.deleteSuccessType = configItem.deleteSuccessType;
            this.deleteErrorTypes = configItem.deleteErrorTypes;
        },
        getItem() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet))
            params[this.keyName] = this.itemKey
            this.$api.$item[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type !== 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.itemData = res.List[0];
                if (!util.isEmpty(res.Log)) {
                    this.itemData.Log = res.Log;
                }
            })

        },
        getItemCategory() {
            let params = {}
            this.$api.$item.getItemCategory(params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1) {
                    return false;
                }
                this.itemCategoryList = res.List


            })
        },
        writeConfirm() {
            this.createConfirm({
                content: '저장하시겠습니까?',
                confirm: () => {
                    this.writeItem()
                },
            })
        },
        writeItem() {
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet))
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            if (this.itemKey !== '') {
                params.i_idx = this.itemKey;
            }
            params.ic_idx = this.itemData.ic_idx
            params.i_type = this.itemData.i_type
            try {
                this.$api.$item[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    if (!res.List.Data.Status) {
                        EventBus.$emit('apiLoading', false);
                        this.isRunning = false;
                        this.errorAlert('아이템 수정에 실패하였습니다');
                        return false;
                    }

                    //s3파일 등록 및 api 등록
                    if (!util.isEmpty(this.deleteFiles)) {
                        this.runS3ApiDeleteFiles(this.deleteFiles)
                    }
                    if (!util.isEmpty(this.fileInfo)) {
                        this.itemIdx = res.List.Data.Data.Basic.Data.Item.Data.i_idx;
                        this.setMultiFileUpload(this.itemIdx, this.fileInfo)
                    } else {
                        this.writeAfterFunc()
                    }
                });

            } catch (e) {
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                console.log(e);
            }
        },
        setMultiFileUpload(key, fileInfo) {
            if (Array.isArray(key)) {
                util.Array.each(key, (data, index, arr) => {
                    this.runUploadFileInfo(fileInfo, 0, data).then(res => {
                        if (key.length === index + 1) {
                            this.writeAfterFunc();
                        }
                    })
                });
            } else {
                this.runUploadFileInfo(fileInfo, 0, key).then(res => {
                    this.writeAfterFunc();
                })
            }
        },
        writeAfterFunc() {
            this.createAlert({
                content: '저장되었습니다.',
                hide: () => {
                    this.getItem()
                }
            });
        },
        deleteConfirm() {
            this.createConfirm({
                content: `아이템 삭제시 해당 아이템에 대한 복구가 불가능합니다.<br>삭제하시겠습니까?`,
                confirmText: '삭제',
                confirm: () => {
                    this.deleteItem(this.itemKey);
                },
                cancel: () => {
                }
            })
        },
        deleteItem() {
            let params = {
                i_idx: this.itemKey
            }
            this.$api.$item[this.deleteFunc](params).then(res => res.Data.Result.List).then(res => {
                if (!res.Data.Status) {
                    this.errorAlert('삭제에 실패했습니다.');
                    return
                }
                this.createAlert({
                    title: '',
                    content: '삭제되었습니다.',
                    hide: () => {
                            this.$router.back();
                    },
                })

            })
        },
        setItemSellingStatus(ty,params){
            this.$api.$item[ty](params).then(res => res.Data.Result).then(res => {
                if(res.Info.type === 1){
                    this.createAlert({content : '처리 완료되었습니다.',hide:()=>{this.getItem()}})
                }else {
                    this.errorAlert('처리에 실패했습니다.')
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
